import request from '@/utils/request'
import type { ResponseData } from '@/utils/request'
import type { LoginScheme, ChangePasswordScheme } from './schemes'

// 查询是否允许新用户注册
export const getAllowSignup = (): Promise<ResponseData<any>> => {
  return request({
    url: '/config/public/allow_signup',
    method: 'GET',
  })
}

// 登录
export const login = (data: LoginScheme): Promise<ResponseData<any>> => {
  return request({
    url: '/biz/admin/login',
    method: 'POST',
    data,
  })
}

// 登出
export const logout = (): Promise<ResponseData<any>> => {
  return request({
    url: '/biz/logout',
    method: 'POST',
  })
}

// 修改密码
export const changePassword = (data: ChangePasswordScheme): Promise<ResponseData<any>> => {
  return request({
    url: '/biz/user/password',
    method: 'POST',
    data,
  })
}
